<template>
  <div>
    <!-- <div
      v-resize="setContentHeight"
      id="helpDiv"
      style="color: white"
      :class="[
        { 'inset-box-shadow': !isMobileOrStandaloneMode },
        onsiteDetected ? 'bg-blue-radial' : 'bg-teal-radial',
      ]"
    > -->
    <div
      v-resize="setContentHeight"
      id="helpDiv"
      style="color: white"
      :class="[
        { 'inset-box-shadow': !isMobileOrStandaloneMode },
        onsiteDetected ? 'bg-blue-dark' : 'bg-blue-dark',
      ]"
    >
      <v-toolbar dark color="transparent" elevation="0">
        <v-btn icon @click="goBack" style="z-index: 1">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title
          style="position: absolute; left: -4px; width: 100vw"
          class="text-center headlinex"
        >
          <strong>Onsite Detector</strong>
        </v-toolbar-title>
      </v-toolbar>

      <div
        ref="helpScrollable"
        class="scrollable box-shadow-inset"
        style="overflowx: hidden"
      >
        <!-- Select library -->
        <div @click="inputPopupSelectBranch.show = true">
          <v-text-field
            solo
            dark
            hide-details
            backgroundColor="transparent"
            label="Library"
            class="mx-5 mt-5"
            readonly
            :value="inputPopupSelectBranch.selectedItem.name"
          >
          </v-text-field>

          <InputPopupSelect
            title="Library"
            :list="settings.menus.branchMenus"
            :select.sync="inputPopupSelectBranch"
          />
        </div>

        <v-textarea
          id="geoRange"
          ref="geoRange"
          solo
          dark
          hide-details
          label="Geolocation range"
          backgroundColor="transparent"
          rows="10"
          class="ma-5"
          :value="
            inputPopupSelectBranch.selectedItem.name
              ? JSON.stringify(
                  inputPopupSelectBranch.selectedItem.geolocationInfo,
                  null,
                  2
                )
              : ''
          "
        ></v-textarea>

        <v-textarea
          solo
          dark
          hide-details
          label="Realtime Geolocation"
          backgroundColor="transparent"
          class="ma-5"
          rows="6"
          readonly
          v-model="geolocationInfo"
        ></v-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import InputPopupSelect from "@/components/InputPopupSelect";
import geolocationHelper from "@/helpers/geolocationHelper";

export default {
  name: "OnsiteDetector",
  components: {
    InputPopupSelect,
  },
  data: () => ({
    onsiteDetected: false,
    onsiteDetectionTimer: null,
    geolocationInfo: null,
    inputPopupSelectBranch: {
      show: false,
      selectedItem: {
        name: null,
        code: null,
      },
    },
  }),
  methods: {
    setContentHeight() {
      if (this.$refs.helpScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.helpScrollable.style.height = contentHeight + "px";
      }
    },
    startOnsiteDetection() {
      if (this.onsiteDetectionTimer) {
        return;
      }

      const getCurrentGeolocationBrowserCallback = (locationInfo) => {
        locationInfo.time = moment().format("h:mm:ss.SSS a");
        this.geolocationInfo = JSON.stringify(locationInfo, null, 2);

        let onsiteDetectedTemp = false;

        const geoRangeStr = document.getElementById("geoRange").value;
        let geoRange = this.parseJson(geoRangeStr);

        if (geoRange) {
          onsiteDetectedTemp = geolocationHelper.isInRange(
            locationInfo.longitude,
            locationInfo.latitude,
            geoRange
          );
        }

        this.onsiteDetected = onsiteDetectedTemp;

        const themeColor = this.onsiteDetected ? "#0047BB" : "#0047BB";
        // themeColor = "#1976D2"; (archived) (if onsiteMode)
        // themeColor = "#00796B"; (archived)
        this.setPrimaryColor(themeColor);

        const statusBarColor = this.onsiteDetected ? "#0047BB" : "#0047BB";
        // themeColor = "#0d47a1"; (archived) (if onsiteMode)
        // themeColor = "#004d40"; (archived)
        this.setStatusBackgroundBarColor(statusBarColor);
      };

      geolocationHelper.getCurrentGeolocationBrowser(
        getCurrentGeolocationBrowserCallback
      );

      this.onsiteDetectionTimer = setInterval(() => {
        geolocationHelper.getCurrentGeolocationBrowser(
          getCurrentGeolocationBrowserCallback
        );
      }, 500);
    },
    endOnsiteDetection() {
      if (this.onsiteDetectionTimer) {
        clearInterval(this.onsiteDetectionTimer);
        this.onsiteDetectionTimer = null;
      }
    },
    parseJson(jsonStr) {
      if (jsonStr) {
        try {
          const result = JSON.parse(jsonStr);

          if (typeof result === "object") {
            return result;
          }
        } catch (e) {}
      }

      return null;
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());

    // this.setStatusBackgroundBarColor("#004d40");
    this.setStatusBackgroundBarColor("#0047BB");

    this.startOnsiteDetection();
  },
  deactivated() {
    this.setThemeColorByMode();

    this.endOnsiteDetection();
  },
  beforeRouteLeave(to, from, next) {
    const inputs = [this.inputPopupSelectBranch];

    for (let i of inputs) {
      if (i != null && i.show) {
        i.show = false;

        next(false);
        return;
      }
    }

    next();
  },
};
</script>